import React from "react";
import AbstractTextInput from "./AbstractTextInput";
import Rules from "../../../../../config/rules";
import {ValidatorForm} from "react-material-ui-form-validator";

class PasswordInput extends AbstractTextInput
{

    componentDidMount() {
        ValidatorForm.addValidationRule('isValidPassword', Rules.isValidPassword);
        if (this.props.confirmPassword !== undefined ) ValidatorForm.addValidationRule('isPasswordMatch', this.isPasswordMatch);
    }

    componentWillUnmount() {
        ValidatorForm.removeValidationRule('isValidPassword');
        if (this.props.confirmPassword !== undefined ) ValidatorForm.removeValidationRule('isPasswordMatch');
    }

    isPasswordMatch = (value) => {
        value = value.replace(/ /gi, '');
        if (this.props.confirmPassword) {
            if (Rules.isValidPassword(value)) {
                return value === this.props.confirmPassword;
            }
        } else {
            return true
        }
    }

    getValidatorsByCase = () => {
        if (!this.props.isOptional) {
            return this.props.confirmPassword === undefined ? ['required', 'isValidPassword'] : ['required', 'isValidPassword', 'isPasswordMatch']
        } else {
            return this.props.confirmPassword === undefined  ? ['isValidPassword']: ['isValidPassword', 'isPasswordMatch']
        }
    }

    getErrorMessagesByCase = () => {
        if (!this.props.isOptional) {
            return this.props.confirmPassword === undefined ? [Rules.txtRequis, Rules.txtInValidPassword] : [Rules.txtRequis, Rules.txtInValidPassword, Rules.txtisPasswordMatch]
        } else {
            return this.props.confirmPassword === undefined ? [Rules.txtInValidPassword]: [Rules.txtInValidPassword, Rules.txtisPasswordMatch]
        }
    }

    label = "Mot de passe*";

    validators = this.getValidatorsByCase();

    errorMessages = this.getErrorMessagesByCase();

    specs = {
        textTransform: 'regular',
        autoComplete: 'new-password',
        form: {
            autoComplete: 'off',
        },
        inputProps: {
            maxLength: 150,
            autoComplete: 'new-password',
            type: 'password'
        }
    }
}

export default PasswordInput